import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import ComproDLS from 'comprodls-sdk';
import { of } from 'rxjs';
import { ApiGatewayHelperService } from '../../app/services/apigateway-helper.service';
import { CacheService } from '../../app/services/cache.service';
import { map } from 'rxjs/operators';

@Injectable()
export class PushXService {
    //Map containing key as orgid/extUserId and Value as grantCredentials
    //Orgid for DLS organisation related events
    //ExtUserId for spaces related events 
    private pushXGrantCredentials = new Map<string, any>();

    private pushx : any;
    constructor (
        private http: HttpClient,
        private apiGatewayHelperService : ApiGatewayHelperService,
        private cacheService : CacheService
     ){}
    

    //Grant using dls Organisation
    grantByOrgId(orgId,spaceId) {
        if(!this.cacheService.getCachingStatus('pushXGrantCredentialsMap')) {
            this.clearPushXGrantCredentialsMap();
            this.cacheService.setCachingStatus('pushXGrantCredentialsMap', true);
        } 
        if(!this.getPushXGrantCredentials(orgId)) {
            return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'grant/org' , { orgId, spaceId })
            .pipe(map((res) =>  {
                this.setPushXGrantCredentials(orgId, res);
                return res;
            }));
        } else {
            return of(this.getPushXGrantCredentials(orgId));
        }
    }

    //Grant using ExtUser Id and Account Id
    public grantByAccountId(refId: string) {
        if (!this.cacheService.getCachingStatus('pushXGrantCredentialsMap')) {
            this.clearPushXGrantCredentialsMap();
            this.cacheService.setCachingStatus('pushXGrantCredentialsMap', true);
        }
        if (!this.getPushXGrantCredentials(refId)) {
            return this.http.post(this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'grant/account', { refId })
                .pipe(map((res) => {
                    this.setPushXGrantCredentials(refId, res);
                    return res;
                }));
        } else {
            return of(this.getPushXGrantCredentials(refId));
        }
    }
    
    //Map key can be orgid/refId
    connect(mapKey, pollingOptions?: {
        accountid?: string;
        pollingEndpoint?: string;
        pollingIterations ?: number;
        pollingInterval ?: number;
    }) {

        /**
         * Default polling endpoint is set to getPushEvents
         * This can be overridden by passing pollingEndpoint in pollingOptions
         * If Events are not received via PushX in case of Error, polling is done to get the events via pollingEndpoint
         * 
         * If rest pollingOptions(like pollingIterations) is not passed, default polling options are set by the SDK
         */
        pollingOptions = {
            accountid: DLS_ACCOUNT_ID,
            pollingEndpoint: this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'getPushEvents',
            ...pollingOptions
        };

        const comproDLS = ComproDLS.init(DLS_ENV, DLS_REALM);
        this.pushx = comproDLS.PushX();
        //Connect to PushX using grantCredentials and pollingOptions
        const pushXConnection = this.pushx.connect({
          ...this.getPushXGrantCredentials(mapKey),
          ...pollingOptions,
        });
        return pushXConnection;
    }

    getPushXConnection(mapKey, pollingOptions?: {
        pollingEndpoint?: string;
        pollingIterations ?: number;
        pollingInterval ?: number;
    }) {
        /**
         * Default polling endpoint is set to getPushEvents
         * This can be overridden by passing pollingEndpoint in pollingOptions
         * If Events are not received via PushX in case of Error, polling is done to get the events via pollingEndpoint
         * 
         * If rest pollingOptions(like pollingIterations) is not passed, default polling options are set by the SDK
         */
        pollingOptions = {
            pollingEndpoint: this.apiGatewayHelperService.getApiGatewayPrefixUrl() + 'getPushEvents',
            ...pollingOptions
        };
        return this.connect(
            mapKey,
            pollingOptions
        );
    }

    cleanup() {
        if(this.pushx) {
            this.pushx.cleanup();
        }
    }
    //Getters and setters for PushXGrantCredentials

    //Map key can be orgid/refId
    setPushXGrantCredentials(mapKey, grantCredentials) {
        this.pushXGrantCredentials.set(mapKey, grantCredentials);
    }

    getPushXGrantCredentials(mapKey) {
        return this.pushXGrantCredentials.get(mapKey);
    }
    clearPushXGrantCredentialsMap() {
        this.pushXGrantCredentials.clear();
    }

}